<template>
  <div id="app">
    <img src="@/assets/og-image.png" alt hidden />
    <header>
      <TheHeader id="navigation-menu" />
    </header>
    <main id="main">
      <transition mode="out-in">
        <router-view />
      </transition>
    </main>
    <footer>
      <TheFooter></TheFooter>
    </footer>
  </div>
</template>
<script>
import TheHeader from "@/components/TheHeader";
import TheFooter from "@/components/TheFooter";
export default {
  components: {
    TheHeader,
    TheFooter
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss">
*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  @include reset-css();
}
::selection {
  background: $verde-exception;
  color: #fff;
}
#app {
  font-family: $fonte-primaria, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $cor-primaria;
  height: 100vh;
  @include flexbox(column);
  align-items: center;
}
header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#main {
  flex: 1;
  width: 90vw;
  padding-top: 5vh;
}
.page-title {
  margin: 0 0 20px 0;
  font-size: 3rem;
  line-height: 3rem;
  margin-bottom: 40px;
  @include for-tablet-portraid-up {
    font-size: 4rem;
    line-height: 4rem;
  }
}
.highlight {
  display: inline-block;
  &::after {
    margin-top: 5px;
    content: "";
    display: block;
    width: 100%;
    height: 10px;
    background: $verde-exception;
  }
}
footer {
  width: 100%;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter {
  transform: translate3d(30px, 0, 0);
}

.v-leave-to {
  transform: translate3d(-30px, 0, 0);
}
.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
